import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const VERSION_URL = '/version.json';
const MIN_INTERVAL_MS = 60 * 1000; // 최소 1분 간격으로만 체크

export function useVersionCheck() {
  const location = useLocation();
  const initialVersion = useRef(null); // 앱 최초 로드 시 버전 저장
  const lastChecked    = useRef(0);    // 마지막 체크 시각 (과도한 요청 방지)

  // 최초 마운트 시 현재 버전 기록. 실패해도 세션 비활성으로 조용히 처리.
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${VERSION_URL}?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        initialVersion.current = data.v ?? null;
        lastChecked.current = Date.now();
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('[versionCheck] 초기 버전 조회 실패 — 세션 동안 버전 체크 비활성화:', e);
        }
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // pathname 변경 시 버전 체크 (페이지 이동 정의: pathname 변경)
  useEffect(() => {
    if (!initialVersion.current) return;
    if (Date.now() - lastChecked.current < MIN_INTERVAL_MS) return;

    (async () => {
      try {
        const res = await fetch(`${VERSION_URL}?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();

        if (data.v && data.v !== initialVersion.current) {
          window.location.reload();
        }
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('[versionCheck] 버전 조회 실패:', e);
        }
      } finally {
        lastChecked.current = Date.now();
      }
    })();
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
}
